// Frontend retirement policy. Contract circuit breakers remain authoritative.
export const isRetiredNetwork = (network) =>
  network === 'bifrost' || network === 'bifrost-test';

export const isLendingRetired = (network) =>
  [
    'bsc',
    'bsc-test',
    'avalanche',
    'avalanche-test',
    'kaia',
    'kaia-test',
    'klaytn',
    'klaytn-test',
  ].includes(network);

export const isLegacyActionBlocked = (network, action) =>
  isRetiredNetwork(network) ||
  (isLendingRetired(network) &&
    ['deposit', 'borrow', 'btc.deposit', 'btc.borrow'].includes(action));
